module.exports = __webpack_public_path__ + "static/img/image_support_article_details_p6.580cc06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_p6.png
// module id = xUmb
// module chunks = 10